import {RelativeDateRule} from "./utils";

export type RelativeDatePreset =
    | 'yesterday'
    | 'today'
    | 'tomorrow'
    | 'last 7 days'
    | 'last week'
    | 'this week'
    | 'next week'
    | 'last month'
    | 'this month'
    | 'next month';

export const datePresets: { preset: RelativeDatePreset; label: string }[] = [
    {preset: 'yesterday', label: 'Yesterday'},
    {preset: 'today', label: 'Today'},
    {preset: 'tomorrow', label: 'Tomorrow'},
    {preset: 'last 7 days', label: 'Last 7 Days'},
    {preset: 'last week', label: 'Last Week'},
    {preset: 'this week', label: 'This Week'},
    {preset: 'next week', label: 'Next Week'},
    {preset: 'last month', label: 'Last Month'},
    {preset: 'this month', label: 'This Month'},
    {preset: 'next month', label: 'Next Month'},
];

export const PRESET_RULES: Record<RelativeDatePreset, RelativeDateRule> = {
    yesterday: {kind: 'bounded', direction: 'last', amount: 1, unit: 'day'},
    today: {kind: 'bounded', direction: 'current', unit: 'day'},
    tomorrow: {kind: 'bounded', direction: 'next', amount: 1, unit: 'day'},
    'last 7 days': {kind: 'bounded', direction: 'last', amount: 7, unit: 'day'},
    'last week': {kind: 'bounded', direction: 'last', amount: 1, unit: 'week'},
    'this week': {kind: 'bounded', direction: 'current', unit: 'week'},
    'next week': {kind: 'bounded', direction: 'next', amount: 1, unit: 'week'},
    'last month': {kind: 'bounded', direction: 'last', amount: 1, unit: 'month'},
    'this month': {kind: 'bounded', direction: 'current', unit: 'month'},
    'next month': {kind: 'bounded', direction: 'next', amount: 1, unit: 'month'},
};